module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"share-twitter":"Partager sur Twitter","share-facebook":"Partager sur Facebook"}}')
  delete Component.options._Ctor
}
